exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-fdcfa9de]::-webkit-inner-spin-button,input[data-v-fdcfa9de]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-fdcfa9de]{-moz-appearance:textfield}.tanpawrap[data-v-fdcfa9de]{white-space:nowrap}", ""]);

// exports
